import { useAppDispatch } from "../../state/hooks";
import { closeStandardModal } from "../../state/slice/modal/modalSlice";
import { XIcon } from "@heroicons/react/outline";

const CloseButton = () => {
  const dispatch = useAppDispatch();

  return (
    <button
      id="gallery-close-button"
      className="z-50 top-2 right-4 absolute"
      type="button"
      onClick={() => {
        dispatch(closeStandardModal("modalPreviewAvatar3d"));
      }}
    >
      <XIcon className="w-6 h-6" />
    </button>
  );
};

export default CloseButton;
